import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import type { Fleet } from "~/modules/fleet/models/Fleet.interface";
import fleetService from "~/modules/fleet/services/fleet.service";

export function useGetFleet({ organizationCode }: GenericParameters) {
  const isLoading = ref(false);
  const result = ref<Fleet>();
  const error = ref<LxcError | undefined>();

  async function getFleet(uid: string): Promise<void> {
    isLoading.value = true;

    result.value = undefined;
    error.value = undefined;

    const response = await fleetService.getOrganizationFleet({
      organizationCode,
      uid,
    });

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    getFleet,
    result,
    error,
    isLoading,
  };
}
